let htmlPolicy: { createHTML(html: string): string } | null | undefined;

/** Pages that enforce Trusted Types only let `DOMParser` take HTML through a policy. */
export function trusted(html: string): string {
  if (htmlPolicy === undefined) {
    htmlPolicy = null;
    const factory = (
      globalThis as {
        trustedTypes?: {
          createPolicy(
            name: string,
            rules: { createHTML(html: string): string },
          ): {
            createHTML(html: string): string;
          };
        };
      }
    ).trustedTypes;
    try {
      // Parsing into an inert document runs nothing; what is kept of it is decided node by node.
      htmlPolicy =
        factory?.createPolicy("z-editor-paste", { createHTML: (input) => input }) ?? null;
    } catch {
      htmlPolicy = null;
    }
  }
  return htmlPolicy === null ? html : htmlPolicy.createHTML(html);
}
